import React from "react";
import { Button } from "@blueprintjs/core";
import styles from "./OpportunityDetails.module.scss";
import { Icon } from "../../atoms/Icon";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";

function OpportunityDetails({
  currentUser,
  opportunityDetails,
  location,
  logout,
  onAlertOpen
}) {
  const history = useHistory();
  const dollarOpportunityAmount = !opportunityDetails.amount
    ? "$0.00"
    : `$${opportunityDetails.amount.toFixed(2)}`;
  const commission =
    opportunityDetails.isPercentage && opportunityDetails.amount
      ? `${opportunityDetails.amount.toFixed(2)}%`
      : dollarOpportunityAmount;

  const ctaButtonText =
    opportunityDetails.visibility === "Public"
      ? "Join this Opportunity"
      : "Apply for this Opportunity";

  return (
    <div className={styles.oppDetail}>
      <label className={styles.heading}>Offer Details</label>

      <div className={`${styles.details} ${styles.private}`}>
        <div className={styles.detail}>
          <Icon size={16} color="#39bc5b" name="tick-circle" />
          <label>{commission} per sale</label>
        </div>
        <div className={styles.detail}>
          <Icon size={16} color="#39bc5b" name="tick-circle" />
          <label>
            Valid till: {moment(opportunityDetails.expiresAt).format("MM/D/YY")}
          </label>
        </div>
        <div className={styles.detail}>
          <Icon size={16} color="#39bc5b" name="tick-circle" />
          <label>
            {opportunityDetails.visibility === "Public"
              ? "Approval Not Needed"
              : "Approval Needed"}
          </label>
        </div>
      </div>
      <div className={styles.bottomActions}>
        <Button
          disabled={
            currentUser &&
            (!opportunityDetails.isApplicable ||
              opportunityDetails.product.owner.id === currentUser.sub)
          }
          className="filled btn-applyOpportunity"
          text={ctaButtonText}
          onClick={() => {
            !currentUser
              ? history.push("/influencer/login", { from: location })
              : onAlertOpen();
          }}
        />

        {currentUser &&
          opportunityDetails.product.owner.id !== currentUser.sub &&
          opportunityDetails.isApplicable && (
            <span className={styles.textInfo}>
              Signed in as @{currentUser.nickname}. Not you?
              <a onClick={logout}> Sign Out</a>
            </span>
          )}

        {currentUser &&
          opportunityDetails.product.owner.id === currentUser.sub && (
            <span className={styles.textInfo}>
              You can't join this opportunity since you own the product
            </span>
          )}

        {currentUser &&
          !opportunityDetails.isApplicable &&
          opportunityDetails.product.owner.id !== currentUser.sub && (
            <span className={styles.textInfo}>
              You can't join this opportunity since you have already applied for
              it.
            </span>
          )}

        {!currentUser && (
          <span className={styles.textInfo}>
            You can't apply since you are not logged in.{" "}
            <Link
              to={{
                pathname: "/influencer/login",
                state: {
                  from: location
                }
              }}
            >
              Sign In
            </Link>
          </span>
        )}
      </div>
    </div>
  );
}

export default OpportunityDetails;
